// extracted by mini-css-extract-plugin
export default {"row":"ResetPassword_row__EOOgP","col":"ResetPassword_col__6LO+I","reset-pw":"ResetPassword_reset-pw__WjfRs"};